import request from '@/utils/request'

/**
 * 用户登录授权
 * @param {*} data
 */
export const user_login = (params) => {
  return request({
    url: `/auth/mobile/login`,
    method: 'get',
    params
  })
}

// 发送验证码
export const send_mobile_sms = params => {
  return request({
    url: `/auth/mobile/sms/send`,
    method: 'get',
    params
  })
}

// 获取用户信息
export const user_info = (params) => {
  return request({
    url: `/user/info`,
    method: 'get',
    params
  })
}
export const get_other_user_info = userId => {
  return request({
    url: `/api/user/info?userId=${userId}`,
    method: 'get'
  })
}

// 绑定身份证
export const bind_idcard = (params) => {
  return request({
    url: `/user/bind/idcard`,
    method: 'get',
    params
  })
}

// 发送验证码
export const send_sms = (regionCode, phoneNumber) => {
  return request({
    url: `/user/sms/send?regionCode=${regionCode}&phoneNumber=${phoneNumber}`,
    method: 'get'
  })
}

// 绑定手机
export const bind_phone = (regionCode, phoneNumber, smsCode) => {
  return request({
    url: `/user/bind/phone?regionCode=${regionCode}&phoneNumber=${phoneNumber}&smsCode=${smsCode}`,
    method: 'get'
  })
}

/**
 * 绑定用户信息
 * @param {*} data
 */
export const bind_user = data => {
  return request({
    url: `/user/bind`,
    method: 'post',
    data: data
  })
}
